export default "__VITE_ASSET__ChKE1L10__"